/**
 * @generated SignedSource<<37662ea835b18c40256b3e8a631efaff>>
 * @relayHash bd58f6efe40054df9e7091b5039c9fd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 472606f55a9efaab0ff5bdac80be0d5d82ee482d333d483cfcf09ba971319cac

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ActivitiesFilterType = "AND" | "OR" | "%future added value";
export type ActivityFilter = {
  actors?: ReadonlyArray<string> | null;
  arguments?: ActivityFilterArgs | null;
  rootContainerIds?: ReadonlyArray<string> | null;
  type?: ActivitiesFilterType | null;
};
export type ActivityFilterArgs = {
  containerIds?: ReadonlyArray<string> | null;
  earliestStart?: AGG$DateTime | null;
  eventTypes?: ReadonlyArray<string> | null;
  latestStart?: AGG$DateTime | null;
  objectTypes?: ReadonlyArray<string> | null;
  products?: ReadonlyArray<string> | null;
  transitions?: ReadonlyArray<TransitionFilter> | null;
};
export type TransitionFilter = {
  from: string;
  to: string;
};
export type SmartsRecommendationsQuery = {
  context: SmartsContext;
  excludeInactive?: boolean | null;
  excludeSelf?: boolean | null;
  maxNumberOfResults?: number | null;
  modelRequestParams: SmartsModelRequestParams;
  requestingUserId: string;
  sessionId?: string | null;
};
export type SmartsContext = {
  additionalContextList?: ReadonlyArray<SmartsKeyValue> | null;
  containerId?: string | null;
  excludeCollaboratorRecommendations?: boolean | null;
  objectId?: string | null;
  product?: string | null;
  tenantId: string;
  userId: string;
};
export type SmartsKeyValue = {
  key: string;
  value: string;
};
export type SmartsModelRequestParams = {
  caller: string;
  experience: string;
  featureServiceModel?: string | null;
};
export type singlePersonKnowledgeCardRelayQuery$variables = {
  filter?: ActivityFilter | null;
  first: number;
  recommendationsQuery: SmartsRecommendationsQuery;
  reportingLinesAaid: string;
  reportingLinesOrgId: string;
  reportingLinesSiteId: string;
  singleUserAccountId: string;
  singleUserRequestingUserId: string;
  singleUserTenantId: string;
};
export type singlePersonKnowledgeCardRelayQuery$data = {
  readonly activity: {
    readonly workedOn: {
      readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_workedOn">;
    };
  } | null;
  readonly knowledgeDiscovery: {
    readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_reportingLines" | "singlePersonKnowledgeCardRelay_user">;
  } | null;
  readonly smarts: {
    readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_smarts">;
  } | null;
};
export type singlePersonKnowledgeCardRelayQuery = {
  response: singlePersonKnowledgeCardRelayQuery$data;
  variables: singlePersonKnowledgeCardRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationsQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesAaid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesOrgId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesSiteId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserAccountId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserRequestingUserId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserTenantId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "recommendationsQuery",
    "variableName": "recommendationsQuery"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "singleUserAccountId"
  },
  {
    "kind": "Variable",
    "name": "requestingUserId",
    "variableName": "singleUserRequestingUserId"
  },
  {
    "kind": "Variable",
    "name": "tenantId",
    "variableName": "singleUserTenantId"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "aaid",
    "variableName": "reportingLinesAaid"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "reportingLinesOrgId"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "reportingLinesSiteId"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = {
  "kind": "ScalarField",
  "name": "picture"
},
v19 = {
  "kind": "ScalarField",
  "name": "email"
},
v20 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v21 = [
  (v20/*: any*/)
],
v22 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      (v18/*: any*/),
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": (v21/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "singlePersonKnowledgeCardRelay_workedOn"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_smarts"
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_user"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_reportingLines"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "singlePersonKnowledgeCardRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluencePageLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceBlogPostLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceBlogPost"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceWhiteboardLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceWhiteboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "webUrl"
                                  }
                                ],
                                "type": "JiraIssue"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "href"
                                  }
                                ],
                                "type": "BitbucketPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "loomUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v16/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v16/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v16/*: any*/),
                                "type": "MercuryPortfolio"
                              }
                            ]
                          },
                          (v15/*: any*/)
                        ]
                      },
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "SmartsRecommendedUser",
            "kind": "LinkedField",
            "name": "recommendedUser",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v19/*: any*/),
                      {
                        "concreteType": "AtlassianAccountUserExtendedProfile",
                        "kind": "LinkedField",
                        "name": "extendedProfile",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  },
                  (v15/*: any*/)
                ]
              },
              (v15/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "singleUser",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryUserProfile",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "department"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "location"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "organization"
                      },
                      {
                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                        "kind": "LinkedField",
                        "name": "thirdPartyIntegrations",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "externalId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "integrationId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "product"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeDiscoverySingleUser"
              }
            ]
          },
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "reportingLines",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v22/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": true,
                    "selections": (v22/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": true,
                    "selections": (v22/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "peers",
                    "plural": true,
                    "selections": (v22/*: any*/)
                  }
                ],
                "type": "KnowledgeDiscoveryReportingLines"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "472606f55a9efaab0ff5bdac80be0d5d82ee482d333d483cfcf09ba971319cac",
    "metadata": {},
    "name": "singlePersonKnowledgeCardRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3b96d2345c405f05720744ecd857cd6a";

export default node;
